<template>
  <iframe-page
    :src="src"
    :title="title"
    :back-link="backLink"
    @iframe-message="handleMessage"
  >
    <modal-popup
      ref="modal"
    >
      <template v-slot:header>
        <h1>
          Share
        </h1>
      </template>
      <template v-slot:body>
        <img
          v-if="shareImage"
          :src="shareImage"
        >
        <p v-show="!showShareButtons">
          Saving your Landscape ({{ progress }}%)
        </p>
        <share-widget
          v-show="showShareButtons"
          ref="sharer"
          :url="shareUrl"
          :download-url="downloadUrl"
          title="Check out my landscape design art, just like Roberto Burle Marx. Create your own and see how yours compares!"
          description="Check out my landscape design art, just like Roberto Burle Marx. Create your own and see how yours compares!"
          @share="handleShare"
        />
      </template>
      <template v-slot:footer />
    </modal-popup>
  </iframe-page>
</template>

<script>
import IframePage from './IframePage'
import ShareWidget from '../components/ShareWidget'
import ModalPopup from '../components/ModalPopup'
import axios from 'axios'
import config from '../config.js'
import TemplateImage from '../assets/vl/sharetemplate.png'

export default {
    name: 'BurleMarxQuiz',
    components: {
        IframePage,
        ModalPopup,
        ShareWidget
    },
    props: {
      title: {
          type: String,
          default: ''
      },
      backLink: {
          type: [String, Object, Boolean],
          default: false
      }
    },
    data() {
        return {
            src: process.env.BASE_URL + 'frames/virtual-landscape/',
            level: 'bottom',
            shareImage: false,
            shareUrl: false,
            downloadUrl: false,
            showShareButtons: false,
            progress: 0
        }
    },
    methods: {
        handleShare(event) {
          this.$gtm.trackEvent({
            category: 'Virtual Landscape',
            action: 'Share - ' + event,
          })
        },
        loadImage(url) {
          return new Promise((resolve, reject) => {
            let img = new Image();
            img.addEventListener('load', () => resolve(img));
            img.addEventListener('error', () => {
              reject(new Error(`Failed to load image's URL: ${url}`));
            });
            img.src = url;
          });
        },
        async createShareImage(url) {

          const img = await this.loadImage(url)
          const template = await this.loadImage(TemplateImage)

          const canvas = document.createElement('canvas')
          canvas.width = 1000
          canvas.height = 500
          const ctx = canvas.getContext('2d')
          ctx.drawImage(template, 0, 0)
          ctx.drawImage(img, 331, 48, 338, 379)
          const durl = canvas.toDataURL('image/png')
          return durl
        },
        async handleMessage(event) {
            if (event.data.event == 'view-level') {
                this.level = event.data.data
            }

            if (event.data.event == 'share-landscape') {
              this.shareImage = event.data.image
              this.$refs.modal.open()
              // 338 x 379
              // 331, 48
              // const img = await this.createShareImage(event.data.image)
              // this.shareImage = img
              axios.post(
                config.share_upload_endpoint,
                this.shareImage,
                {
                crossdomain: true,
                onUploadProgress: (e) => {
                  this.progress = parseInt( Math.round( ( e.loaded * 100 ) / e.total ) )
                }
              }).then((response) => {
                  this.shareUrl = event.data.url + encodeURI(response.data) + '/'
                  this.downloadUrl = config.shared_upload_root + '/' + response.data + '?forcedl=1'
                  this.showShareButtons = true
              })
            }
        },
        popdownModal() {
          this.$refs.modal.close()
        }
    }
}
</script>